import { createStore } from 'vuex';
import locations from '../data/locations.json'
import boxes from '../data/boxes.json'
import markers from '../data/markers.json'
export default createStore({
  state() {
    return {
      vars: 123,
      locations: locations,
      boxes, boxes,
      markers, markers,
      location: null,
      showAcknowledgement: true,
      showPreview: false,
      showDetail: false,
      mapScale: 1,
      zoomLevel: 1
    };
  },
  mutations: {
    setLocation(state, payload) {
      state.location = payload
    },
    setShowAcknowledgement(state, payload) {
      state.showAcknowledgement = payload
    },
    setShowPreview(state, payload) {
      state.showPreview = payload
    },
    setShowDetail(state, payload) {
      state.showDetail = payload
    },
    setMapScale(state, payload) {
      state.mapScale = payload
    },
    setZoomLevel(state, payload) {
      state.zoomLevel = payload
    },
  },
  actions: {},
  getters: {
    getLocations(state) {
      return state.locations
    },
    getLocation(state) {
      return state.location
    },
    getBoxes(state) {
      return state.boxes
    },
    getMarkers(state) {
      return state.markers
    },
    getShowAcknowledgement(state) {
      return state.showAcknowledgement;
    },
    getShowPreview(state) {
      return state.showPreview;
    },
    getShowDetail(state) {
      return state.showDetail;
    },
    getMapScale(state) {
      return state.mapScale
    },
    getZoomLevel(state) {
      return state.zoomLevel
    },
  }
});